























import { computed, defineComponent } from '@vue/composition-api';
import { usePreventWindowClose } from './hooks/usePreventWindowClose';
import StagingBanner from './components/banners/StagingBanner.vue';
import UploadViewer from './components/share/UploadViewer.vue';
import { BootstrapStore } from './store/singletons/Bootstrap';
import { UploadsStore } from './store/singletons/UploadsStore';
import { CurrentUserStore } from './store/singletons/User';
import StatusPage from './views/StatusPage.vue';

export default defineComponent({
	name: 'App',
	components: {
		UploadViewer,
		StatusPage,
		StagingBanner,
	},
	setup(props, ctx) {
		const { uploads, errors, clear: clearUploads } = UploadsStore;
		const onCancelledClose = () => {
			// eslint-disable-next-line no-alert
			window.alert(ctx.root.$t('upload-viewer.incomplete-confirmation'));
		};
		usePreventWindowClose(computed(() => uploads.value.length > 0), onCancelledClose);
		BootstrapStore.getInstance().bootstrap();

		const isStaging = computed(() => process.env.VUE_APP_ENV_NAME !== 'production');

		return {
			clearUploads,
			uploads,
			errors,
			isBootstrapComplete: BootstrapStore.getInstance().isBootstrapComplete,
			// Settings
			isStaging,
			isCsr: CurrentUserStore.isCsr,
			isLoggedIn: CurrentUserStore.isLoggedIn,
		};
	},
});
